export default __webpack_public_path__ + "static/media/HTMLCircularBackground-light-sepia-200px.jpg.3667bcef.webp";